import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  Box,
  Button,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Modal
} from '@material-ui/core';
import { DataGrid } from '@material-ui/data-grid';
import { makeStyles, createMuiTheme } from '@material-ui/core/styles';

import { updatePurchaseOrderReceived, updatePurchaseOrderProducts } from 'redux/actions';

const mapStateToProps = (state) => ({
  newPurchaseOrder: state.newPurchaseOrder
});

const defaultTheme = createMuiTheme();
const useStyles = makeStyles(
  (theme) => {
    const isDark = theme.palette.mode === 'dark';

    return {
      root: {
        '& .MuiDataGrid-cell--editing': {
          backgroundColor: 'rgb(255,215,115, 0.19)',
          color: '#1a3e72',
        },
        '& .Mui-error': {
          backgroundColor: `rgb(126,10,15, ${isDark ? 0 : 0.1})`,
          color: isDark ? '#ff4343' : '#750f0f',
        },
      },
    };
  },
  { defaultTheme }
);

const ReceiveProductsModal = (props) => {

  const classes = useStyles();

  const { displayId, poProducts, total } = props.newPurchaseOrder;

  //this is a unique case where the `id` used for DataGrid is the
  //database id given to the PurchaseOrderProduct.
  const [updatedProducts, setUpdatedProducts] = useState(
    poProducts.map(poProduct => ({
      ...poProduct,
      arrivedQuantity: 0,
      pendingQuantity: poProduct.totalQuantity - poProduct.receivedQuantity
    }))
  );
  const [editRowsModel, setEditRowsModel] = useState({});
  
  const columns = [
    { field: 'displayId', headerName: 'Product ID', flex: 1 },
    { field: 'name', headerName: 'Product Name', flex: 1 },
    { field: 'unitCost', headerName: 'Cost', type: 'number', flex: 1 },
    { field: 'totalQuantity', headerName: 'Total Quantity', type: 'number', flex: 1 },
    { field: 'receivedQuantity', headerName: 'Received Quantity', type: 'number', flex: 1 },
    { field: 'arrivedQuantity', headerName: 'Arrived Quantity', type: 'number', flex: 1, editable: true },
    { field: 'pendingQuantity', headerName: 'Pending Quantity', type: 'number', flex: 1 }
  ];

  const handleEditCellChangeCommitted = React.useCallback(({ id, field, props }) => {
    const arrivedIndex = updatedProducts.findIndex(updatedProduct => updatedProduct.id === id);
    setUpdatedProducts([
      ...updatedProducts.slice(0, arrivedIndex),
      {
        ...updatedProducts[arrivedIndex],
        arrivedQuantity: parseFloat(props.value),
        pendingQuantity: updatedProducts[arrivedIndex].totalQuantity - (updatedProducts[arrivedIndex].receivedQuantity + parseFloat(props.value))
      },
      ...updatedProducts.slice(arrivedIndex + 1)
    ]);
  }, [updatedProducts]);

  const handleEditRowsModelChange = React.useCallback((newModel) => {
    const updatedModel = { ...newModel };
    
    Object.keys(updatedModel.model).forEach((id) => {
      if (updatedModel.model[id].arrivedQuantity) {
        const currentValue = parseFloat(updatedModel.model[id].arrivedQuantity.value);
        const currentProduct = updatedProducts.find(product => product.id === parseFloat(id));
        const changeIsValid = ( currentValue + currentProduct.receivedQuantity <= currentProduct.totalQuantity && currentValue >= 0 );
        updatedModel.model[id].arrivedQuantity = { ...updatedModel.model[id].arrivedQuantity, error: !changeIsValid };
      }
    });
    setEditRowsModel(updatedModel.model.model);
  }, [updatedProducts]);

  const saveArrivedProducts = () => {
    //This is a temporary method to get the purchaseOrder id. improve it. also PurchaseOrdersTable already
    //gets the purchaseOrderInfo using the find method, so here we are doing it twice.
    const purchaseOrderInfo = props.purchaseOrders.find(purchaseOrder => purchaseOrder.displayId === displayId && purchaseOrder.total === total);

    let arrivedProducts = [];
    let incrementProducts = [];
    for ( let i = 0; i < updatedProducts.length; i++ ) {
      const updatedProduct = updatedProducts[i];
      if(updatedProduct.arrivedQuantity > 0) {
        arrivedProducts.push({
          id: updatedProduct.id,
          arrivedQuantity: updatedProduct.arrivedQuantity
        });
        incrementProducts.push({
          id: updatedProduct.productId,
          incrementQuantity: updatedProduct.arrivedQuantity
        });
      }
    }

    //checks if all products are received and sets Status to 'Received'.
    if(updatedProducts.every(updatedProduct => updatedProduct.pendingQuantity === 0)) props.updatePurchaseOrderReceived(purchaseOrderInfo.id);

    //Updates the Received Quantities of the Purchase Orders.
    props.updatePurchaseOrderProducts({purchaseOrderId: purchaseOrderInfo.id, arrivedProducts}, incrementProducts);

    props.closeModal(true);
  };

  return (
    <Modal open={props.open}>
      <Card>
        <CardHeader
          subheader="Enter the Amount of Received Products"
          title="Receive Products"
        />
        <Divider />
        <CardContent>
          <Box style={{
            overflow: 'auto',
            height: 318
          }}>
            <DataGrid
              className={classes.root}
              rows={updatedProducts}
              columns={columns}
              editRowsModel={editRowsModel}
              onEditRowModelChange={handleEditRowsModelChange}
              onEditCellChangeCommitted={handleEditCellChangeCommitted}
              disableSelectionOnClick
              hideFooter
              localeText={{
                noRowsLabel: 'No Products'
              }}
            />
          </Box>
        </CardContent>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            p: 2
          }}
        >
          <Button
            disabled={updatedProducts.every(updatedProduct => updatedProduct.arrivedQuantity === 0)}
            color="primary"
            variant="contained"
            onClick={saveArrivedProducts}
          >
            Save Products
          </Button>
          <Button sx={{ mx: 1 }} onClick={props.closeModal.bind(this, true)}>
            Cancel
          </Button>
        </Box>
      </Card>
    </Modal>
  )
};

export default connect (mapStateToProps, {updatePurchaseOrderReceived, updatePurchaseOrderProducts}) (ReceiveProductsModal);